export default {
  "content": "<title>Back</title><path d=\"M0 10.995C0 17.063 4.937 22 11.005 22 17.067 22 22 17.064 22 10.995 22 4.933 17.067 0 11.005 0 4.937 0 0 4.933 0 10.995zm20 0C20 15.96 15.966 20 11.006 20 6.04 20 2 15.96 2 10.996 2 6.036 6.04 2 11.004 2 15.964 2 20 6.033 20 10.994zm-13.71.707l3.998 3.998 1.414-1.414-2.292-2.292h6.583v-2H9.41l2.292-2.29-1.414-1.414-3.998 3.998a.998.998 0 000 1.414z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "22",
    "height": "22",
    "viewBox": "0 0 22 22",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};